<div  class="main_content">
    <div #page_section class="page_main_sec">
        <div class="dashboard_main_sec">
            <div>
                <div class="post-nav-wrap">
                    <div class="title-wrap">
                        <p class="title">Dashboard <button (click)="openChartView()">Chart View</button></p>
                    </div>
                    <div class="work-item-btn-wrp">
                        <a *ngFor="let worklist of lstWorkListFilter" class="work-item-btn" [class.active]="selectedWorklistId==worklist.worklist_id" (click)="onSelectFilterWorkList(worklist.worklist_id)">
                            {{worklist.worklist_text}} <span class="work-item-count">{{getWorklistCountByDoctype(worklist.documents)}}</span>
                        </a>
                        
                    </div>
                    <div class="search-box top-search" *ngIf="isDisplaySearchBox">
                        <img src="../../../assets/img/search.png"  alt="Search" />
                        <input type="search" [(ngModel)]="searchURN" (search)="clearSearch()" autocomplete="off" class="search-input" placeholder="URN" />
                        <span class="search-button search-data" (click)="getSearchTransaction()"><i class="material-icons">search</i></span>
                    </div>
                    <ul class="nav top-actions">
                        <li>
                            <a (click)="onIconSearchClick()" class="search-icon pointerCursor" title="Search">
                              
  
                                <i class="material-icons theme-text-color">search</i>
                            </a>
                        </li>
                        <li>
                            <a (click)="showFilterModel();" class="pointerCursor" title="Filter">
                               
                                <i class="material-icons theme-text-color">filter_list</i>
                            </a>
                        </li>
                       
                        <li>
                            <a (click)="flipProcess=!flipProcess;selectedRowIndex=-1;selectedCellIndex=-1;" title="{{flipProcess?'Process > Document Type':'Document Type > Process'}}" class="pointerCursor">
                                <i class="material-icons theme-text-color">sync</i>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/home']" title="Home">
                                <i class="material-icons theme-text-color">home</i>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="shadowBox cardM">
                    <ul class="inactivityRep" >
                     
                        <li class="active"><span class="icon iconLatestdoc cgx-i cgx-i_SeoCalculator"></span><span class="card06Tl">TOTAL IDEAS</span><span class="cCount"> 
                            
                            <div *ngIf="commonService.selectedRole!=240 ? true: false;">
                            <div class="tabBtn" [ngClass]="IsCommanPoolPOselected==true?'active':''" type="button" (click)="onTileClick('Common Pool',0,'Common Pool Powering Idea')">
                                <span class="cCount">{{total}}</span>
                                <!-- <span class="cCount">{{invooicecommanpool_po}}</span> -->
                            </div>
                        </div>

                        <div *ngIf="commonService.selectedRole==240 ? true: false;">                           
                                <span class="cCount">{{total}}</span>                           
                        </div> 
                      </span>
                    </li>

                    <li *ngIf="commonService.selectedRole==244 ? true: false;" class="active"><span class="icon iconLatestdoc cgx-i cgx-i_Atom"></span><span class="card06Tl">IMPLEMENTABLE IDEA</span>
                        <span class="cCount">                         
                            <div class="tabBtn"  [ngClass]="IsCommanPoolPOselected==true?'active':''"  type="button" (click)="onTileClick('Common Pool',0,'Common Pool Powering Idea')">
                                <span class="cCount">{{implementableideas}}</span>                           
                            </div>  
                        </span>
                    </li>


                        <li  *ngIf="commonService.selectedRole==244 ? false: true;" class="active"><span class="icon iconLatestdoc cgx-i cgx-i_TargetAudience"></span><span class="card06Tl">MY IDEAS</span>
                            
                            <span class="cCount">
                            
                            <div class="tabBtn"  [ngClass]="IsCommanPoolPOselected==true?'active':''"  type="button" (click)="onTileClick('Common Pool',1,'Common Pool Powering Idea')">
                                <span class="cCount">{{getmyideas}}</span>
                                <!-- <span class="cCount">{{total}}</span> -->
                            </div>


                        </span></li> 


                        <!-- <li class="active"><span class="icon iconLatestdoc cgx-i cgx-i_PeopleTarget"></span><span class="card06Tl">MAX IDEA GENERATED BY WINNER</span><span class="cCount">{{total}}</span></li>
                         -->
                        <li class="active"><span class="icon iconLatestdoc cgx-i cgx-i_Success"></span><span class="card06Tl">IDEA WINNER</span><span class="cCount">Suraj</span></li>
                       
                       
                        <!-- <li class="wCTabs" >
                            <div class="iconTtl">
                                <span class="icon iconLatestdoc cgx-i cgx-i_TargetAudience"></span>
                                <h3 class="subTitle01-1">Ideas Allocated to me</h3>
                            </div>
                            <button class="tabBtn" [ngClass]="IsallocatedPOselected==true?'active':''" type="button" (click)="onTileClick('Allocated', 'Allocated Powering Idea')">
                                <span class="card06Tl">Powering Idea</span><span class="cCount">{{invoiceallocate_po}}</span>
                            </button>
                            <button class="tabBtn" [ngClass]="IsallocatedNonPOselected==true?'active':''" type="button" (click)="onTileClick('Allocated', 'Allocated Order to Cash')">
                                <span class="card06Tl">Order to Cash</span><span class="cCount">{{invoiceallocate_nonpo}}</span>
                            </button>
                        </li> -->
                        <!-- <li class="wCTabs">
                          <div class="iconTtl">
                              <span class="icon iconLatestdoc cgx-i cgx-i_PeopleTarget"></span>
                              <h3 class="subTitle01-1">Ideas in Common Pool</h3>
                          </div>
                          <button class="tabBtn" [ngClass]="IsCommanPoolPOselected==true?'active':''" type="button" (click)="onTileClick('Common Pool','Common Pool Powering Idea')">
                              <span class="card06Tl">Powering Idea</span><span class="cCount">{{invooicecommanpool_po}}</span>
                          </button>
                          <button class="tabBtn" [ngClass]="IsCommanPoolNonPOselected==true?'active':''" type="button" (click)="onTileClick('Common Pool','Common Pool Order to Cash')">
                              <span class="card06Tl">Order to Cash</span><span class="cCount">{{invooicecommanpool_nonpo}}</span>
                          </button> 
                      </li> -->
  
                    </ul>
                </div>
                <div *ngIf="commonService.selectedRole==244 ? false: true;"   class="serviceChainWrp shadowBox">
                  
                    <h3 class="subTitle01-1">Ideas Value Chain</h3>
                    <div class="serviceChainValueWrp timeline hrztal">
                        <div class="valueChainWrp">
                            <div class="valueCol start">
                                <div class="valueIcnWrp CGX-GY-40L"><span class="cgx-i cgx-i-m cgx-i_Gear"></span></div>
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                    <path
                                        id="Path_47234"
                                        data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"
                                    ></path>
                                </svg>
                            </div>
                            <div class="valueCol" (click)="onDetailTileClick('Draft Idea')">
                                <div class="valueIcnWrp CGX-BL-00N"><span class="cgx-i cgx-i_Attestation"></span></div>
                                <h4 class="subTitle03">Draft Idea</h4>
                                <span class="vCount CGX-BL-00N">{{New_Invoices}}</span>
                              
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                    <path
                                        id="Path_47234"
                                        data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"
                                    ></path>
                                </svg>
                            </div>
                            
                            <!-- <div class="valueCol" (click)="onDetailTileClick('PL Approval')">
                              <div class="valueIcnWrp CGX-DY-100AP"><span class="cgx-i cgx-i_MobileOptions"></span></div>
                                <h4 class="subTitle03">PL Approval</h4>
                                <span class="vCount CGX-DY-100AP">{{Indexing}}</span>
                               
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                  <path
                                      id="Path_47234"
                                      data-name="Path 47234"
                                      d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                      transform="translate(-0.876 -1.564)"
                                  ></path>
                              </svg>
                            </div> -->

                            <div class="valueCol" (click)="onDetailTileClick('SME Approval')">
                                <div class="valueIcnWrp CGX-DY-00N"><span class="cgx-i cgx-i_MobileOptions"></span></div>
                                <h4 class="subTitle03">SME Approval</h4>
                                <span class="vCount CGX-DY-00N">{{SME_Query}}</span>
                               
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                    <path
                                        id="Path_47234"
                                        data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"
                                    ></path>
                                </svg>
                            </div> 
                            
                            <div class="valueCol" (click)="onDetailTileClick('Send back for Review')">
                                <div class="valueIcnWrp CGX-GN-00N"><span class="cgx-i cgx-i_BackLinksLine"></span></div>
                                <h4 class="subTitle03">Send back for Review</h4>
                                <span class="vCount CGX-GN-00N">{{SME_Review}}</span>
                              
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                    <path
                                        id="Path_47234"
                                        data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"
                                    ></path>
                                </svg>
                            </div> 
                            <div class="valueCol" (click)="onDetailTileClick('TPM Approval')">
                                <div class="valueIcnWrp CGX-DY-100AP"><span class="cgx-i cgx-i_ApprovalDocument"></span></div>
                                <h4 class="subTitle03">TPM Approval</h4>
                                <span class="vCount CGX-DY-100AP">{{TPM_Query}}</span>
                              
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                    <path
                                        id="Path_47234"
                                        data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"
                                    ></path>
                                </svg>
                            </div>             
                                  <div class="valueCol" (click)="onDetailTileClick('Hold')">
                                    <div class="valueIcnWrp CGX-DY-00N"><span class="cgx-i cgx-i_Stopwatch"></span></div>
                                      <h4 class="subTitle03">Hold</h4>
                                      <span class="vCount CGX-PR-00N">{{Ex_On_Hold}}</span>
                                    
                                      <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                        <path
                                            id="Path_47234"
                                            data-name="Path 47234"
                                            d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                            transform="translate(-0.876 -1.564)"
                                        ></path>
                                    </svg>
                                  </div>
                           
                            

                            <!-- <div class="valueCol" (click)="onDetailTileClick('Business Case Submitted')">
                                <div class="valueIcnWrp CGX-GN-00N"><span class="cgx-i cgx-i_Tic"></span></div>
                                <h4 class="subTitle03">Business Case Submitted</h4>
                                <span class="vCount CGX-GN-00N">{{TPM_Response}}</span>
                             
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                    <path
                                        id="Path_47234"
                                        data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"
                                    ></path>
                                </svg>
                            </div>
                            <div class="valueCol" (click)="onDetailTileClick('Business Case Approved')">
                                <div class="valueIcnWrp CGX-BL-00N"><span class="cgx-i cgx-i_Attestation"></span></div>
                                <h4 class="subTitle03">Business Case Approved</h4>
                                <span class="vCount CGX-BL-00N">{{Development}}</span>
                              
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                    <path
                                        id="Path_47234"
                                        data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"
                                    ></path>
                                </svg>
                            </div> -->
                            <div class="valueCol" (click)="onDetailTileClick('Benefit Realization')">
                                <div class="valueIcnWrp CGX-PR-00N"><span class="cgx-i cgx-i_SmartGoal"></span></div>
                                <h4 class="subTitle03">Benefit Realization</h4>
                                <span class="vCount CGX-PR-00N">{{Benefit_Realization}}</span>
                               
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                    <path
                                        id="Path_47234"
                                        data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"
                                    ></path>
                                </svg>
                            </div>
                
                            <!-- <div class="valueCol" (click)="onDetailTileClick('Implementation')">
                                <div class="valueIcnWrp CGX-RD-00N"><span class="cgx-i cgx-i_SeoAudits"></span></div>
                                <h4 class="subTitle03">Implementation</h4>
                                <span class="vCount CGX-RD-00N">{{Ex_Trash}}</span>
                              
                                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                    <path
                                        id="Path_47234"
                                        data-name="Path 47234"
                                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                        transform="translate(-0.876 -1.564)"
                                    ></path>
                                </svg>
                            </div>
                                                      
                           
                          <div class="valueCol" (click)="onDetailTileClick('Requirement Gathering')">
                            <div class="valueIcnWrp CGX-DO-00N"><span class="cgx-i cgx-i_Startup"></span></div>
                            <h4 class="subTitle03">Requirement Gathering</h4>
                            <span class="vCount CGX-DO-00N">{{Gathering_Requirements}}</span>
                    
                            <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                <path
                                    id="Path_47234"
                                    data-name="Path 47234"
                                    d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                    transform="translate(-0.876 -1.564)"
                                ></path>
                            </svg>
                        </div>
                                             
                            
                          <div class="valueCol" (click)="onDetailTileClick('Build')">
                            <div class="valueIcnWrp CGX-BL-00N"><span class="cgx-i cgx-i_Attestation"></span></div>
                            <h4 class="subTitle03">Build</h4>
                            <span class="vCount CGX-GN-00N">{{Implementable}}</span>
                         
                            <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                              <path
                                  id="Path_47234"
                                  data-name="Path 47234"
                                  d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                  transform="translate(-0.876 -1.564)"
                              ></path>
                          </svg>
                        </div>
                                                
  
                    <div class="valueCol" (click)="onDetailTileClick('UAT')">
                      <div class="valueIcnWrp CGX-GN-00N"><span class="cgx-i cgx-i_Tic"></span></div>
                      <h4 class="subTitle03">UAT</h4>
                      <span class="vCount CGX-GN-00N">{{UAT}}</span>
                    
                      <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                          <path
                              id="Path_47234"
                              data-name="Path 47234"
                              d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                              transform="translate(-0.876 -1.564)"
                          ></path>
                      </svg>
                  </div>
  
                  <div class="valueCol" (click)="onDetailTileClick('Go Live')">
                    <div class="valueIcnWrp CGX-DO-00N"><span class="cgx-i cgx-i_Startup"></span></div>
                    <h4 class="subTitle03">Go Live</h4>
                    <span class="vCount CGX-DO-00N">{{Deployed_Production}}</span>
            
                    <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                        <path
                            id="Path_47234"
                            data-name="Path 47234"
                            d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                            transform="translate(-0.876 -1.564)"
                        ></path>
                    </svg>
                  </div> -->

                  
                      
  
                            <div class="valueCol end">
                                <div class="valueIcnWrp CGX-GY-00N"><span class="cgx-i cgx-i-m cgx-i_DestinationMap"></span></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div  class="serviceChainWrp shadowBox">
                    <h3 class="subTitle01-1">Implementation Value Chain</h3>
                    <div class="serviceChainValueWrp exptn">
                        <div class="valueCol" (click)="onDetailTileClick('Initiate Implementation')">
                            <div class="valueIcnWrp CGX-RD-00N"><span class="cgx-i cgx-i_SeoAudits"></span></div>
                            <h4 class="subTitle03">Implementation</h4>
                            <span class="vCount CGX-RD-00N">{{Ex_Trash}}</span>
                          
                            <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                                <path
                                    id="Path_47234"
                                    data-name="Path 47234"
                                    d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                    transform="translate(-0.876 -1.564)"
                                ></path>
                            </svg>
                        </div>
                                                  
                       
                      <div class="valueCol" (click)="onDetailTileClick('Design')">
                        <div class="valueIcnWrp CGX-DO-00N"><span class="cgx-i cgx-i_DesignCheckList"></span></div>
                        <h4 class="subTitle03">Design</h4>
                        <span class="vCount CGX-DO-00N">{{Gathering_Requirements}}</span>
                
                        <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                            <path
                                id="Path_47234"
                                data-name="Path 47234"
                                d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                                transform="translate(-0.876 -1.564)"
                            ></path>
                        </svg>
                    </div>
                                         
                        
                      <div class="valueCol" (click)="onDetailTileClick('Build')">
                        <div class="valueIcnWrp CGX-BL-00N"><span class="cgx-i cgx-i_BuildingBlocks"></span></div>
                        <h4 class="subTitle03">Build</h4>
                        <span class="vCount CGX-GN-00N">{{Implementable}}</span>
                     
                        <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                          <path
                              id="Path_47234"
                              data-name="Path 47234"
                              d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                              transform="translate(-0.876 -1.564)"
                          ></path>
                      </svg>
                    </div>
                                            

                <div class="valueCol" (click)="onDetailTileClick('UAT')">
                  <div class="valueIcnWrp CGX-GN-00N"><span class="cgx-i cgx-i_Tic"></span></div>
                  <h4 class="subTitle03">UAT</h4>
                  <span class="vCount CGX-GN-00N">{{UAT}}</span>
                
                  <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                      <path
                          id="Path_47234"
                          data-name="Path 47234"
                          d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                          transform="translate(-0.876 -1.564)"
                      ></path>
                  </svg>
              </div>

              <div class="valueCol" (click)="onDetailTileClick('Go Live')">
                <div class="valueIcnWrp CGX-DO-00N"><span class="cgx-i cgx-i_Startup"></span></div>
                <h4 class="subTitle03">Go Live</h4>
                <span class="vCount CGX-DO-00N">{{Deployed_Production}}</span>
        
                <svg class="connector CGX-GY-90L"  width="71.044" height="71.044" viewbox="0 0 71.044 71.044">
                    <path
                        id="Path_47234"
                        data-name="Path 47234"
                        d="M42.682,1.564C38.316,25.907,25.086,39,.876,43.37A54.551,54.551,0,0,1,30.114,72.608C34.48,48.4,47.577,35.168,71.92,30.8A53.7,53.7,0,0,1,42.682,1.564"
                        transform="translate(-0.876 -1.564)"
                    ></path>
                </svg>
              </div>

              

                    </div>



                <div class="serviceChainWrp shadowBox">
  
                   
                    
                </div>
            </div>
        </div>
    </div>
  </div>
